export const backendUrl = process.env.REACT_APP_BACKEND_URL;
export const secretPass = process.env.REACT_APP_SECRET_PASS;
export const currency = process.env.REACT_APP_CURRENCY
export const email = process.env.REACT_APP_EMAIL
export const password = process.env.REACT_APP_PASSWORD
//firebase credentail
// export const email = 'ramneek@mindmoverz.in'
// export const password = '12345678'